var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 41,
    viewBox: "0 0 22 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39841 10.6154C4.4368 10.1026 3.7134 9.23465 3.3823 8.19637C3.05121 7.15809 3.13858 6.03157 3.6258 5.05676L3.86877 4.56448H0.803161C0.232938 6.13945 0.248778 7.86706 0.847784 9.4313C1.44679 10.9955 2.58892 12.2919 4.06526 13.0831L7.75624 15.0923L9.09784 12.631L5.39841 10.6154Z",
    fill: "#3762FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4346 9.41113L12.0008 10.0006C12.7569 10.7861 13.1766 11.8356 13.1707 12.9258C13.1648 14.016 12.7337 15.0609 11.9691 15.8381L10.2515 17.6065L12.2586 19.5672L13.9741 17.8072C15.0441 16.718 15.727 15.3077 15.9178 13.7928C16.1087 12.2779 15.7969 10.7423 15.0305 9.4217L11.4346 9.41113Z",
    fill: "#3762FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2395 33.393C11.2811 32.8732 10.5634 32 10.239 30.9591C9.91467 29.9181 10.0093 28.7918 10.5028 27.8196L10.7648 27.2998H7.68014C7.09674 28.8734 7.10054 30.6047 7.69085 32.1757C8.28115 33.7468 9.41834 35.0522 10.8936 35.8523L13.0571 37.0312L14.4008 34.5719L12.2395 33.393Z",
    fill: "#3762FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8129 18.8847L18.2038 19.5375C18.7684 20.4702 18.9468 21.5865 18.7009 22.6487C18.4551 23.7109 17.8045 24.6353 16.8875 25.2251L14.8255 26.5603L16.3509 28.914L18.415 27.5766C19.8136 26.6758 20.844 25.3046 21.3202 23.7107C21.7964 22.1167 21.6869 20.405 21.0116 18.8847H17.8129Z",
    fill: "#3762FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7593 34.7029L9.94303 40.8806H13.0255L15.3115 35.8671C16.611 33.0391 17.0338 29.8867 16.5254 26.8163C16.0171 23.7458 14.6009 20.898 12.4593 18.6397C10.7084 16.7904 9.54873 14.4611 9.12835 11.9494C8.70798 9.43771 9.04606 6.85771 10.0994 4.53913L12.1213 0.0706482H9.043L7.54505 3.38556C6.26064 6.2101 5.84816 9.35363 6.36041 12.4139C6.87265 15.4742 8.28631 18.3121 10.4205 20.5644C12.1772 22.4183 13.3387 24.7557 13.7555 27.2754C14.1723 29.7952 13.8254 32.3821 12.7593 34.7029Z",
    fill: "#3762FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a4e66bf2ede9b75141ab05dc477cd6b.svg";
export { ForwardRef as ReactComponent };